import { createMutationAtom } from 'atoms/create-resource-atom';
import type {
  EntityReconcileCreateResponse,
  EntityReconcilePreviewResponse,
} from 'types/api-responses';

// ---------------------------------------------------------------------------
// Entity Page Reconciliation mutation atoms — one per tearsheet endpoint on
// Entities::ReconciliationsController. Same payload contracts as the document
// structuring reconcile (the backend facility is shared); only the URLs and the
// extended preview/create responses differ. Undo posts directly from the hooks
// (see ./api), so it needs no atom.
// ---------------------------------------------------------------------------

export const entityReconcilePreviewAtom = createMutationAtom<
  EntityReconcilePreviewResponse,
  'reconcilePreview'
>();

export const entityReconcileCreateAtom = createMutationAtom<
  EntityReconcileCreateResponse,
  'reconcileCreate'
>();

// "Add as New" (§3.9): canonize an Imported entity from the reconcile screen.
export interface EntityCanonizeResponse {
  importedEntityId: number;
  canonicalEntityId: number;
  name: string;
  entityType: 'IndividualEntity' | 'OrganizationEntity' | 'ImportedEntity';
  // The canonical inherits the imported entity's operator codes, and with them
  // its Operator tag.
  operator: boolean;
  suggestionId: number;
  eventId: number;
}

export const entityCanonizeAtom = createMutationAtom<
  EntityCanonizeResponse,
  'entityCanonize'
>();

export const entityCanonizeUrl = (entityId: number) =>
  `/entities/${entityId}/canonization`;

const reconciliationsBase = (entityId: number) =>
  `/entities/${entityId}/reconciliations`;

export const entityReconcileCreateUrl = (entityId: number) =>
  reconciliationsBase(entityId);

export const entityReconcilePreviewUrl = (entityId: number) =>
  `/entities/${entityId}/reconciliation_preview`;
